import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "../../../styles/MBABatch.css";
import { getFeesDetailsList, saveFeesDetailsList } from "../../../services/getAllApi";

const FeesDetailsTable = ({ students, onFeesDataChange }) => {
  const [formData, setFormData] = useState({});

  const fetchFeesDetails = async () => {
    try {
      const feesResponse = await getFeesDetailsList();

      const initialData = {};
      students.forEach((student) => {
        const studentFees = feesResponse.find((fee) => String(fee.student_id) === String(student.student_id)) || {};
        initialData[student.student_id] = {
          name: studentFees.name || student.name ||"",
          mobile: studentFees.mobile || student.mobile || "",
          application_fees: studentFees.application_fees || "",
          application_fees_date: studentFees.application_fees_date || "",
          application_fees_paid: studentFees.application_fees_paid || false,

          total_fees: studentFees.total_fees || "",
          total_fees_date: studentFees.total_fees_date || "",
          total_fees_paid: studentFees.total_fees_paid || false,

          first_installment: studentFees.first_installment || "",
          first_install_date: studentFees.first_install_date || "",
          first_install_paid: studentFees.first_install_paid || false,

          second_installment: studentFees.second_installment || "",
          second_install_date: studentFees.second_install_date || "",
          second_install_paid: studentFees.second_install_paid || false,

          third_installment: studentFees.third_installment || "",
          third_install_date: studentFees.third_install_date || "",
          third_install_paid: studentFees.third_install_paid || false,

          balance_fees: studentFees.balance_fees ?? 0,
          balance_fees_date: studentFees.balance_fees_date || "",
          balance_fees_paid: studentFees.balance_fees_paid || false,
        };
      });

      setFormData(initialData);
      onFeesDataChange(initialData); // ✅ Pass data to parent

    } catch (error) {
      console.error("Error fetching fees data:", error.message);
    }
  };

  useEffect(() => {
    fetchFeesDetails();
  }, [students]);

  useEffect(() => {
    onFeesDataChange(formData); // ✅ Sync with parent on every update
  }, [formData]);

  // ... rest of your table code ...


  const handleChange = (e, student_id) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    setFormData((prevData) => {
      const updatedStudent = {
        ...prevData[student_id],
        [name]: updatedValue,
      };

      const totalFees = parseFloat(updatedStudent.total_fees) || 0;
      const firstInstall = parseFloat(updatedStudent.first_installment) || 0;
      const secondInstall = parseFloat(updatedStudent.second_installment) || 0;
      const thirdInstall = parseFloat(updatedStudent.third_installment) || 0;

      let balanceFees = totalFees - (firstInstall + secondInstall + thirdInstall);
      if (balanceFees <= 0) balanceFees = 0;

      updatedStudent.balance_fees = balanceFees;

      return { ...prevData, [student_id]: updatedStudent };
    });
  };

  const [isSaving, setIsSaving] = React.useState(false);

  const handleSubmit = async () => {
    setIsSaving(true);
    // Build feesDataArray in the order of students prop to preserve order
    const feesDataArray = students.map((student) => {
      return {
        student_id: student.student_id.toString(), // ✅ match DB type
        name: formData[student.student_id]?.name || student.name || "",
        mobile: formData[student.student_id]?.mobile || student.mobile || "",
        application_fees: formData[student.student_id]?.application_fees || "",
        application_fees_date: formData[student.student_id]?.application_fees_date || "",
        application_fees_paid: formData[student.student_id]?.application_fees_paid || false,
        total_fees: formData[student.student_id]?.total_fees || "",
        total_fees_date: formData[student.student_id]?.total_fees_date || "",
        total_fees_paid: formData[student.student_id]?.total_fees_paid || false,
        first_installment: formData[student.student_id]?.first_installment || "",
        first_install_date: formData[student.student_id]?.first_install_date || "",
        first_install_paid: formData[student.student_id]?.first_install_paid || false,
        second_installment: formData[student.student_id]?.second_installment || "",
        second_install_date: formData[student.student_id]?.second_install_date || "",
        second_install_paid: formData[student.student_id]?.second_install_paid || false,
        third_installment: formData[student.student_id]?.third_installment || "",
        third_install_date: formData[student.student_id]?.third_install_date || "",
        third_install_paid: formData[student.student_id]?.third_install_paid || false,
        balance_fees: formData[student.student_id]?.balance_fees || 0,
        balance_fees_date: formData[student.student_id]?.balance_fees_date || "",
        balance_fees_paid: formData[student.student_id]?.balance_fees_paid || false,
      };
    });


    console.log("Submitting Data:", feesDataArray);

    try {
      const response = await saveFeesDetailsList(feesDataArray);
      console.log("Save response:", response);
      Swal.fire("Success", "Fees Data saved successfully!", "success");

      // Use the updated data from the response instead of fetching again
      if (response.data && response.data.data) {
        const updatedFeesResponse = response.data.data;

        const initialData = {};
        students.forEach((student) => {
          const studentFees = updatedFeesResponse.find((fee) => String(fee.student_id) === String(student.student_id)) || {};
          initialData[student.student_id] = {
            name: studentFees.name || student.name || "",
            mobile: studentFees.mobile || student.mobile || "",
            application_fees: studentFees.application_fees || "",
            application_fees_date: studentFees.application_fees_date || "",
            application_fees_paid: studentFees.application_fees_paid || false,
            total_fees: studentFees.total_fees || "",
            total_fees_date: studentFees.total_fees_date || "",
            total_fees_paid: studentFees.total_fees_paid || false,
            first_installment: studentFees.first_installment || "",
            first_install_date: studentFees.first_install_date || "",
            first_install_paid: studentFees.first_install_paid || false,
            second_installment: studentFees.second_installment || "",
            second_install_date: studentFees.second_install_date || "",
            second_install_paid: studentFees.second_install_paid || false,
            third_installment: studentFees.third_installment || "",
            third_install_date: studentFees.third_install_date || "",
            third_install_paid: studentFees.third_install_paid || false,
            balance_fees: studentFees.balance_fees ?? 0,
            balance_fees_date: studentFees.balance_fees_date || "",
            balance_fees_paid: studentFees.balance_fees_paid || false,
          };
        });

        setFormData(initialData);
        onFeesDataChange(initialData);
      } else {
        // Fallback to fetch if response doesn't have data
        await fetchFeesDetails();
      }
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire("Error", "Failed to save data", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn" disabled={isSaving}>
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">
        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Application Fees</th>
              <th>Total Fees</th>
              <th>1st Installment</th>
              <th>2nd Installment</th>
              <th>3rd Installment</th>
              <th>Balance Fees</th>
            </tr>
          </thead>

          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.student_id}</td>
                <td>{student.name}</td>
                <td>{student.mobile}</td>

                {[
                  { field: "application_fees", dateField: "application_fees_date", checkField: "application_fees_paid" },
                  { field: "total_fees", dateField: "total_fees_date", checkField: "total_fees_paid" },
                  { field: "first_installment", dateField: "first_install_date", checkField: "first_install_paid" },
                  { field: "second_installment", dateField: "second_install_date", checkField: "second_install_paid" },
                  { field: "third_installment", dateField: "third_install_date", checkField: "third_install_paid" },
                  { field: "balance_fees", dateField: "balance_fees_date", checkField: "balance_fees_paid" },
                ].map((fee, idx) => (
                  <td key={idx}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
                      <input
                        type="number"
                        name={fee.field}
                        value={formData[student.student_id]?.[fee.field] ?? 0}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{
                          width: "120px",
                          textAlign: "center",
                          fontWeight: fee.field === "balance_fees" ? "bold" : "normal",
                          color: fee.field === "balance_fees" ? "red" : "black",
                        }}
                        disabled={fee.field === "balance_fees"}
                      />
                      <input
                        type="date"
                        name={fee.dateField}
                        value={formData[student.student_id]?.[fee.dateField] || ""}
                        onChange={(e) => handleChange(e, student.student_id)}
                      />

                      <input
                        type="checkbox"
                        name={fee.checkField}
                        checked={formData[student.student_id]?.[fee.checkField] || false}
                        onChange={(e) => handleChange(e, student.student_id)}
                      />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeesDetailsTable;